module.exports = __webpack_public_path__ + "static/media/_china.87d6c351.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_china.svg
// module id = 2310
// module chunks = 7